import React from 'react'
import styles from './index.module.scss'
const beiAn = require('@/assets/images/home/beian.png')

function Header() {
    let baiduAccess = `
        var _hmt = _hmt || [];
        (function() {
          var hm = document.createElement("script");
          hm.src = "https://hm.baidu.com/hm.js?e084e87981e8288429af127a0c5069fd";
          var s = document.getElementsByTagName("script")[0]; 
          s.parentNode.insertBefore(hm, s);
        })();
    `;
    window._hmt = window._hmt || [];
    eval(baiduAccess);
    return (
        <footer className={`footer lx-text-center lx-bg-color-section ${styles.footer}`}>
            <p className="lx-fz14">
                <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">沪ICP备10000326号-6</a>
                <img src={beiAn} alt="备案"/>
                <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010102007416" target="_blank" rel="noreferrer">沪公网安备 31010102007416号</a>
                <span> ©{new Date().getFullYear()}中国第一汽车集团有限公司 版权所有</span>
            </p>
        </footer>
    );
  }
  
  export default Header;